import { render, staticRenderFns } from "./AddServiceInvoiceVAT.vue?vue&type=template&id=1753344e"
import script from "./AddServiceInvoiceVAT.vue?vue&type=script&lang=js"
export * from "./AddServiceInvoiceVAT.vue?vue&type=script&lang=js"
import style0 from "./AddServiceInvoiceVAT.vue?vue&type=style&index=0&id=1753344e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports